import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  createContest,
  fetchModuleDetails,
  getModuleList,
} from "../../../action/contest";
import trashIcon from "../../../assets/images/trash-03.svg";
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import { SingleErrorMessage } from "../../singleErrorMessage";
import { toast } from "react-hot-toast";
import ThumbnailPicker from "../../../components/ThumbnailPicker/ThumbnailPicker";
import uploadImage from "../../../action/imageUpload";
import { th } from "date-fns/locale";
import showNotification from "../../../components/notification/showNotification";
import { Loader } from "../../../components/loader";

const ContestAdd = () => {
  const { moduleId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [contestDetails, setContestDetails] = useState([]);
  const [quetionType, setQuetionType] = useState("TEXT");
  const [optionType, setOptionType] = useState("TEXT");
  const [optionTypeArr, setOptionTypeArr] = useState([]);
  const [type, setType] = useState(0);
  const [videoType] = useState([
    { name: "Upload Internal Video", value: 0 },
    { name: "Upload External Video", value: 1 },
  ]);

  const getModuleDetails = async () => {
    try {
      const response = await fetchModuleDetails(moduleId);
      if (response.status) {
        let moduleTypeArr = response.data[0]?.moduleType;

        // Set contest and option type arrays
        setContestDetails(moduleTypeArr);
        setOptionTypeArr(moduleTypeArr);
        console.log("moduleTypeArr", moduleTypeArr);
        if (response?.data?.[0]?.moduleCategoryId) {
          addContestFormik.setFieldValue(
            "moduleCategoryId",
            response.data[0]?.moduleCategoryId
          );
        }
        // Check if moduleTypeArr contains only "IMAGE"
        if (moduleTypeArr.length === 1 && moduleTypeArr[0] === "IMAGE") {
          moduleTypeArr.push("TEXT");
          setOptionTypeArr(moduleTypeArr); // Update optionTypeArr to include "TEXT"
        }
        if (response.data[0].moduleType.length == 1) {
          setQuetionType(response.data[0].moduleType[0]);
          if (response.data[0].moduleType[0] === "VIDEO") {
            setOptionType("TEXT");
            setOptionTypeArr(["TEXT"]);
          }
        }
      }
    } catch (error) {
      console.error("Failed to fetch category data", error);
    }
  };

  const addContestFormik = useFormik({
    initialValues: {
      title: { en: "", hi: "", mr: "" },
      moduleId: moduleId,
      options: [{ title: { en: "", hi: "", mr: "" }, isCorrect: false }],
      contestType: "",
      media: "",
      optionType: "",
      extras: { videoUrlType: 0 },
      moduleCategoryId: "",
    },
    onSubmit: async (values) => {
      values.contestType = quetionType;
      values.optionType = optionType;

      if (values.options.length == 1) {
        showNotification("Eror", "Please select 2 or more options", "danger");
        return;
      }

      if (
        quetionType === "VIDEO" &&
        (values.extras.videoUrlType === 0 || values.extras.videoUrlType === 1)
      ) {
        if (
          values.media === null ||
          values.media === undefined ||
          values.media === ""
        ) {
          showNotification("Eror", "Please select media", "danger");
          return;
        }
      }
      if (quetionType === "IMAGE") {
        if (
          values.media === null ||
          values.media === undefined ||
          values.media === ""
        ) {
          showNotification("Eror", "Please select image", "danger");
          return;
        }
      }

      const isEmptyOption = values.options.filter((option) => {
        if (optionType === "TEXT") {
          // Check if any language field in title is empty
          return Object.keys(option.title).some(
            (lang) => !option.title[lang]?.trim()
          );
        } else if (optionType === "IMAGE") {
          // Validate that `option.title.en` contains an uploaded image reference
          return !option.title.en || option.title.en.trim() === "";
        }
        return false; // Default case for unsupported option types
      });
      if (isEmptyOption.length > 0) {
        showNotification("Eror", "Please fill option", "danger");
        return;
      }
      const isCorrectAns = values.options.filter(
        (option) => option.isCorrect == true
      );
      if (quetionType !== "VIDEO" && quetionType !== "IMAGE") {
        delete values.media;
      }
      if (isCorrectAns.length == 0) {
        showNotification(
          "Eror",
          "Please select any one option as correct",
          "danger"
        );
        return;
      }
      console.log("values  ", values);
      const res = await createContest(values);
      if (res.status) {
        showNotification(
          "Success",
          res.message || "Contest created successfully",
          "success"
        );
        navigate(-1);
      } else {
        showNotification(
          "Eror",
          res.message || "An error occurred while creating contest",
          "danger"
        );
      }
    },
  });

  const addMoreOptions = () => {
    addContestFormik.setFieldValue("options", [
      ...addContestFormik.values.options,
      { title: { en: "" }, isCorrect: false },
    ]);
  };

  const addRemoveOptions = (mainIndex) => {
    addContestFormik.setFieldValue(
      "options",
      addContestFormik.values.options.filter(
        (value, index) => index !== mainIndex
      )
    );
  };

  const uploadMediaImage = async (file, type, index) => {
    if (!file?.type?.includes("image")) {
      showNotification("Eror", "Please select an image", "danger");
      return;
    }
    const formData = new FormData();
    formData.append("file", file);
    const res = await uploadImage(formData, "module");
    if (res.status) {
      if (type == 1) addContestFormik.setFieldValue(`media`, res.data[0]);
      else
        addContestFormik.setFieldValue(
          `options[${index}].title.en`,
          res.data[0]
        );
    }
  };

  useEffect(() => {
    getModuleDetails();
  }, []);

  const [videoPreview, setVideoPreview] = useState(null);
  const [loading, setLoading] = useState(false);

  // const handleVideoUpload = async (e) => {
  //   const file = e.target.files[0];
  //   if (file) {
  //     // Create a video element to generate a thumbnail
  //     const videoElement = document.createElement("video");
  //     videoElement.src = URL.createObjectURL(file);
  //     videoElement.currentTime = 1; // Set time at which to capture the thumbnail (e.g., 1 second)

  //     videoElement.onloadeddata = () => {
  //       const canvas = document.createElement("canvas");
  //       canvas.width = videoElement.videoWidth;
  //       canvas.height = videoElement.videoHeight;
  //       const ctx = canvas.getContext("2d");
  //       ctx.drawImage(videoElement, 0, 0, canvas.width, canvas.height);

  //       const thumbnail = canvas.toDataURL("image/png");
  //       setVideoPreview(thumbnail); // Set the thumbnail as preview
  //     };

  //     const formData = new FormData();
  //     formData.append("file", file);

  //     try {
  //       const res = await uploadImage(formData, "module");
  //       if (res.status) {
  //         addContestFormik.setFieldValue(`media`, res.data[0]);
  //       }
  //     } catch (error) {
  //       console.error("Error uploading video:", error);
  //     }
  //   }
  // };
  const handleVideoUpload = async (e) => {
    setLoading(true);
    const file = e.target.files[0];
    if (!file) return;
    const maxSize = 8 * 1024 * 1024; // 8MB in bytes

    if (file.size > maxSize) {
      showNotification(
        "Error",
        "The file size must be less than 8MB.",
        "danger"
      );
      setLoading(false);
      addContestFormik.setFieldValue(`media`, ""); // Reset the file input when size > 8MB
      e.target.value = ""; // Clear the file input to reset the file name
      return;
    } else {
      console.log("selectVideo");

      // Create a video element to generate a thumbnail
      const videoElement = document.createElement("video");
      videoElement.src = URL.createObjectURL(file);
      videoElement.currentTime = 1; // Capture the thumbnail at 1 second

      videoElement.onloadeddata = () => {
        const canvas = document.createElement("canvas");
        canvas.width = videoElement.videoWidth;
        canvas.height = videoElement.videoHeight;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(videoElement, 0, 0, canvas.width, canvas.height);
        const thumbnail = canvas.toDataURL("image/png");
        setVideoPreview(thumbnail); // Set the thumbnail as preview
      };

      const formData = new FormData();
      formData.append("file", file);

      try {
        const res = await uploadImage(formData, "module");
        console.log("Uploading video...");
        console.log("Response:", res);

        if (res.status) {
          addContestFormik.setFieldValue(`media`, res.data[0]);
          console.log("Video uploaded successfully!");
        } else {
          console.log("Upload error");
        }
      } catch (error) {
        console.log("Error uploading video:", error);
      } finally {
        setLoading(false);
      }
    }
  };

  const showCheckbox = (indx) => {
    if (addContestFormik.values.options?.[indx]?.isCorrect === true) {
      return false;
    }
    return (
      addContestFormik.values.options?.some(
        (value) => value?.isCorrect === true
      ) ?? false
    );
  };
  return (
    <div className="payout_data-content">
      <div className="payout_data-head">
        <div className="payout_data-head-top mb-2">
          <div className="payout_data-left">
            <div className="payout_data_ttl">
              <Breadcrumb
                paths={[
                  {
                    name: "Question",
                    link: `/contest/list/${moduleId}`,
                    state: location.state,
                  },
                  { name: "Add Question", link: "/contest/add" },
                ]}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="tab_box">
        <form
          onSubmit={addContestFormik.handleSubmit}
          className="m-4">
          <div className="row">
            {contestDetails?.length > 0 ? (
              <>
                <div className="col-lg-6">
                  <div className="input-box">
                    <div className="input-label">Question Type</div>
                    <div className="input_field">
                      <select
                        required
                        type="text"
                        className="input"
                        placeholder="Level"
                        name="zone"
                        value={
                          contestDetails.length === 1
                            ? contestDetails[0]
                            : quetionType
                        }
                        onChange={(e) => {
                          setQuetionType(e.target.value);
                          if (e.target.value == "VIDEO") {
                            setOptionType("TEXT");
                          }
                        }}>
                        {contestDetails.length > 1 ? (
                          <option value="">Select Question Type</option>
                        ) : (
                          ""
                        )}
                        {contestDetails?.map((value) => {
                          return <option value={value}>{value}</option>;
                        })}
                      </select>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="input-box">
                    <div className="input-label">Option Type</div>
                    <div className="input_field">
                      <select
                        required
                        type="text"
                        className="input"
                        placeholder="Level"
                        name="zone"
                        value={optionType}
                        onChange={(e) => {
                          setOptionType(e.target.value);
                        }}
                        disabled={quetionType == "VIDEO"}>
                        {quetionType === "VIDEO" &&
                        contestDetails.length == 1 ? (
                          <option
                            value="TEXT"
                            selected>
                            TEXT
                          </option>
                        ) : (
                          <>
                            <option value="">Select Option Type</option>
                            {optionTypeArr
                              ?.filter((type) => type !== "VIDEO")
                              .map((value) => {
                                return (
                                  <option
                                    key={value}
                                    value={value}>
                                    {value}
                                  </option>
                                );
                              })}
                          </>
                        )}
                      </select>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              " "
            )}
            <div className="col-lg-6">
              <div className="input-box">
                <div className="input-label">Title (English)</div>
                <div className="input_field">
                  <input
                    required
                    type="text"
                    className="input"
                    name="title.en"
                    placeholder="Enter title"
                    value={addContestFormik.values.title.en}
                    onChange={addContestFormik.handleChange}
                  />
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="input-box">
                <div className="input-label">Title (Hindi)</div>
                <div className="input_field">
                  <input
                    required
                    type="text"
                    className="input"
                    name="title.hi"
                    placeholder="Enter title"
                    value={addContestFormik.values.title.hi}
                    onChange={addContestFormik.handleChange}
                  />
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="input-box">
                <div className="input-label">Title (Marathi)</div>
                <div className="input_field">
                  <input
                    required
                    type="text"
                    className="input"
                    name="title.mr"
                    placeholder="Enter title"
                    value={addContestFormik.values.title.mr}
                    onChange={addContestFormik.handleChange}
                  />
                </div>
              </div>
            </div>
            {quetionType === "VIDEO" ? (
              <>
                <div className="col-lg-6">
                  <div className="input-box">
                    <div className="input-label">Video Type</div>
                    <div className="input_field">
                      <select
                        required
                        type="text"
                        className="input"
                        placeholder="Level"
                        name="extras.videoUrlType"
                        value={addContestFormik.values.extras.videoUrlType}
                        onChange={addContestFormik.handleChange}>
                        <option value="">Select Video Type</option>
                        {videoType?.map((value) => {
                          return (
                            <option
                              key={value.value}
                              value={value.value}>
                              {value.name}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <div className="col-lg-6"></div>
            )}

            <div className="col-lg-6">
              {quetionType == "IMAGE" ? (
                <div className="input-box">
                  <div className="input-label">Image</div>
                  <ThumbnailPicker
                    width="auto"
                    height="250px"
                    onFileSelect={(file) => {
                      const _URL = window.URL || window.webkitURL;

                      const img = new Image();
                      uploadMediaImage(file, 1);

                      img.src = _URL.createObjectURL(file);
                    }}
                    image={addContestFormik.values?.media}
                    accept={"image/*"}
                  />
                </div>
              ) : quetionType == "VIDEO" ? (
                <>
                  {addContestFormik.values.extras.videoUrlType == 0 ? (
                    <div className="input-box">
                      <div className="input-label">Upload video</div>
                      <input
                        type="file"
                        accept="video/*"
                        onChange={handleVideoUpload}
                      />
                      {loading ? (
                        <Loader />
                      ) : (
                        videoPreview && (
                          <div className="mt-3">
                            <img
                              src={videoPreview}
                              alt="Video Thumbnail"
                              style={{ width: "200px", height: "auto" }}
                            />
                          </div>
                        )
                      )}
                    </div>
                  ) : (
                    <div className="input-box">
                      <div className="input-label">Video URL</div>
                      <div className="input_field">
                        <input
                          type="url"
                          className="input"
                          name="media"
                          placeholder="Enter url"
                          value={addContestFormik.values.media}
                          onChange={addContestFormik.handleChange}
                        />
                      </div>
                    </div>
                  )}
                </>
              ) : (
                ""
              )}
            </div>

            <div className="col-lg-6"></div>
            {addContestFormik.values.options?.map((value, index) => {
              return (
                <div className="col-lg-6">
                  {optionType == "TEXT" || quetionType == "VIDEO" ? (
                    <div className="input-box">
                      <div className="input-label option_type">
                        {" "}
                        <div> Option {index + 1}</div>
                        <div className="checkbox_div">
                          <input
                            style={{ width: "auto" }}
                            type="checkbox"
                            className="input"
                            name={`options[${index}].isCorrect`}
                            placeholder="Enter title"
                            value={
                              addContestFormik.values.options[index].isCorrect
                            }
                            onChange={addContestFormik.handleChange}
                            disabled={showCheckbox(index)}
                            // required
                          />
                          <img
                            className="custom_trash"
                            src={trashIcon}
                            onClick={() => {
                              addRemoveOptions(index);
                            }}
                            alt="delete"
                          />
                        </div>
                      </div>
                      <div className="input_field custom_field custom_text">
                        <input
                          // required
                          type="text"
                          className="input"
                          name={`options[${index}].title.en`}
                          placeholder="Enter title in english"
                          value={
                            addContestFormik.values.options[index].title.en
                          }
                          onChange={addContestFormik.handleChange}
                        />
                      </div>
                      <div className="input_field custom_field custom_text">
                        <input
                          // required
                          type="text"
                          className="input custom_input"
                          name={`options[${index}].title.hi`}
                          placeholder="Enter title in hindi"
                          value={
                            addContestFormik.values.options[index].title.hi
                          }
                          onChange={addContestFormik.handleChange}
                        />
                      </div>
                      <div className="input_field custom_field custom_text">
                        <input
                          // required
                          type="text"
                          className="input custom_input"
                          name={`options[${index}].title.mr`}
                          placeholder="Enter title in marathi"
                          value={
                            addContestFormik.values.options[index].title.mr
                          }
                          onChange={addContestFormik.handleChange}
                        />
                      </div>
                    </div>
                  ) : optionType == "IMAGE" ? (
                    <div className="input-box ">
                      <div className="input-label ">Option {index + 1}</div>
                      <div className="custom_img_option">
                        <ThumbnailPicker
                          width="100%"
                          height="250px"
                          onFileSelect={(file) => {
                            const _URL = window.URL || window.webkitURL;

                            const img = new Image();
                            uploadMediaImage(file, 2, index);

                            img.src = _URL.createObjectURL(file);
                          }}
                          image={
                            addContestFormik.values?.options[index].title.en
                          }
                          accept={"image/*"}
                        />
                        <div className="checkbox_div">
                          <input
                            style={{ width: "auto" }}
                            type="checkbox"
                            className="input"
                            name={`options[${index}].isCorrect`}
                            placeholder="Enter title"
                            value={
                              addContestFormik.values.options[index].isCorrect
                            }
                            onChange={addContestFormik.handleChange}
                            disabled={showCheckbox(index)}
                            // required
                          />
                          <img
                            className="custom_trash"
                            src={trashIcon}
                            alt="delete"
                            onClick={() => {
                              addRemoveOptions(index);
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              );
            })}
          </div>

          <div>
            <div>
              <div className="input-box ">
                <div className="flex_btn">
                  <button
                    className="btn btn-primary"
                    type="button"
                    onClick={addMoreOptions}
                    disabled={addContestFormik.values.options.length == 4}>
                    Add More Option
                  </button>
                  <button
                    className="btn btn-success"
                    type="submit"
                    disabled={
                      addContestFormik.values.options.length == 0 || loading
                    }>
                    Save
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ContestAdd;
